<template>
  <el-dialog :visible.sync="visible">
    <span slot="title" style="color: #fff">123</span>
    <el-form label-width="160px">
      <!-- 选择邮箱 -->
      <el-form-item :label="$t('1881')">
        <el-select v-model="selectEmail" clearable :placeholder="$t('221')">
          <el-option v-for="item in optionsEmail" :label="item" :value="item" :key="item"> </el-option>
          <el-option :label="$t('1882')" :value="3"> </el-option>
        </el-select>
      </el-form-item>
      <!-- 请输入 -->
      <el-form-item :label="$t('1256')" v-if="selectEmail === 3">
        <el-input type="text" v-model="email" :placeholder="$t('324')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <!-- 发送 -->
      <el-button type="primary" :disabled="!Boolean(sendEmail)" @click="send" :loading="loading">{{
        $t('225')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { certificateSend } from 'api/payroll/prove-download'

export default {
  data() {
    return {
      loading: false, // 发送loading
      visible: false, // 组件visible
      selectEmail: '', // 选项邮箱
      email: '', // 邮箱
      optionsEmail: [], // 邮箱选项
      cInfo: {} // 当前信息
    }
  },
  computed: {
    // 邮箱取值逻辑
    sendEmail() {
      const { selectEmail, email } = this
      if (selectEmail !== 3) return selectEmail
      return email
    }
  },
  methods: {
    init(target) {
      if (!target) return
      this.cInfo = target
      this.visible = true
      this.selectEmail = ''
      this.email = ''
      this.optionsEmail = []
      target.enterprise_email && this.optionsEmail.push(target.enterprise_email)
      target.personal_email && this.optionsEmail.push(target.personal_email)
    },
    // 发送
    send() {
      this.loading = true
      certificateSend({ ...this.cInfo, email: this.sendEmail })
        .then(res => {
          this.visible = false
          this.$message.success(this.$t('1880'))
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
